import { Pipe, PipeTransform } from '@angular/core';

const defaultTrail = '...';
const defaultLimit = 18;
@Pipe({
  name: 'truncate',
})
export class TruncatePipe implements PipeTransform {
  transform(value: string, args: any[]): string {
    if (!value) {
      return '';
    }

    const limit = args.length > 0 ? parseInt(args[0], defaultLimit) : defaultLimit;
    const trail = args.length > 1 ? args[1] : defaultTrail;
    return value.length > limit ? value.substring(0, limit) + trail : value;
  }
}
